// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customToggleSwitcher .ui-toggle-switcher {\n  width: 1.8em !important;\n}\n.customToggleSwitcher .ui-toggle-switcher.checked .slider {\n  left: 0.8em !important;\n}\n.customToggleSwitcher .ui-toggle-switcher .slider {\n  left: 0!important;\n}\n.customToggleSwitcher .ui-toggle-switcher .slider {\n  height: 1em!important;\n  width: 1em!important;\n}\n", ""]);
// Exports
module.exports = exports;
